import { Token } from '@/constant';
import { makeAutoObservable } from 'mobx';
interface ConfimModal {
    isOpen: boolean;
    attemptingTxn: boolean;
    hash: string;
    pendingText: string;
    errorMessage?: string;
    addTokenToMetamask?: Token;
    summery?: string;
    title?: string;
}

// 聊天窗口状态接口
interface AiChat {
    isOpen: boolean;
    isExpanded: boolean;
}

export const InitConfirmModalConfig = {
    isOpen: false,
    attemptingTxn: false,
    hash: '',
    pendingText: '',
    errorMessage: undefined,
    addTokenToMetamask: undefined,
    title: '',
};

// 初始聊天窗口状态
export const InitAiChatConfig: AiChat = {
    isOpen: false,
    isExpanded: false,
};

export class Application {
    openConnectWallet: boolean = false;
    confirmModal: ConfimModal = InitConfirmModalConfig;
    hideMainnet: boolean = true;
    // comingSoon: boolean = true;
    comingSoon: boolean = false;
    aiChat: AiChat = InitAiChatConfig;
    isExploreNavDrawerOpen: boolean = false;
    isIncubatorDrawerOpen: boolean = false;
    isLazbubuDrawerOpen: boolean = false;
    constructor() {
        makeAutoObservable<this>(this);
    }

    toggleConnectWalletModal = () => {
        this.openConnectWallet = !this.openConnectWallet;
    };

    setConfimModal = (data: ConfimModal) => {
        this.confirmModal = data;
    };
    setCloseConfirModalState = () => {
        this.confirmModal = InitConfirmModalConfig;
    };

    // 控制聊天窗口打开/关闭
    toggleChatOpen = () => {
        this.aiChat.isOpen = !this.aiChat.isOpen;
    };

    // 控制聊天窗口展开/收缩
    toggleChatExpanded = () => {
        this.aiChat.isExpanded = !this.aiChat.isExpanded;
    };

    // 关闭聊天窗口
    closeChat = () => {
        this.aiChat.isExpanded = false;
        this.aiChat.isOpen = false;
    };

    // 控制探索导航抽屉打开/关闭
    toggleExploreNavDrawer = () => {
        this.isExploreNavDrawerOpen = !this.isExploreNavDrawerOpen;
    };

    // 打开探索导航抽屉
    openExploreNavDrawer = () => {
        this.isExploreNavDrawerOpen = true;
    };

    // 关闭探索导航抽屉
    closeExploreNavDrawer = () => {
        this.isExploreNavDrawerOpen = false;
    };

    // 控制 incubator 抽屉打开/关闭
    toggleIncubatorDrawer = () => {
        this.isIncubatorDrawerOpen = !this.isIncubatorDrawerOpen;
    };

    // 打开 incubator 抽屉
    openIncubatorDrawer = () => {
        this.isIncubatorDrawerOpen = true;
    };

    // 关闭 incubator 抽屉
    closeIncubatorDrawer = () => {
        this.isIncubatorDrawerOpen = false;
    };

    // 控制 lazbubu 抽屉打开/关闭
    toggleLazbubuDrawer = () => {
        this.isLazbubuDrawerOpen = !this.isLazbubuDrawerOpen;
    };

    // 打开 lazbubu 抽屉
    openLazbubuDrawer = () => {
        this.isLazbubuDrawerOpen = true;
    };

    // 关闭 lazbubu 抽屉
    closeLazbubuDrawer = () => {
        this.isLazbubuDrawerOpen = false;
    };
}

export default new Application();
